import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../../common/constants';
import utils from '../../../../common/utils';

export default class FeedbackLogsService extends BaseService {
  constructor() {
    super(constants.GET_FEEDBACK_DATA, constants.FEEDBACK_SEARCH_STATUS);
  }

  async handleEvent(eventName, event) {
    const urlEndpoint = constants.FEEDBACK_LOGS_ENDPOINT;
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackbv2').post(urlEndpoint, payload, { headers: enhancedHeaders });
    }
    // Default flow: aiadminv2 with automatic token handling
    return this.getClient('aiadminv2').post(urlEndpoint, payload, { headers });
  }

  handleResponse(response) {
    Framework.getStoreRegistry().getStore('feedbackLogs').setResponse(response.data);
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    }
    Framework.getStoreRegistry().getStore('feedbackLogs').resetStoreValues();
  }
}
